import { AuthProfile } from '@r123/auth';

import { OTPEnquiryCookiesDataType } from '@/modules/enquiry/otp/otp.type';

export function getEnquirerFormat(
    user: AuthProfile | undefined,
    cookies?: OTPEnquiryCookiesDataType,
) {
    if (!user) {
        return {
            enquirer_email: '',
            enquirer_logged_in: false,
            enquirer_name: '',
            enquirer_otp_verified: cookies?.isVerified || false,
            enquirer_phone: '',
        };
    }
    return {
        enquirer_email: user.email,
        enquirer_logged_in: true,
        enquirer_name: user.name,
        enquirer_otp_verified: cookies?.isVerified || false,
        enquirer_phone: user.phone_number,
    };
}
